import { Pipe, PipeTransform, inject } from '@angular/core';
import { AnyAbility } from '@casl/ability';
import { AbilityService } from '@casl/angular';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';
import {
  RoleAction,
  RolePermissionSubject,
  UserRole,
} from '@wilson/interfaces';
import { filter, map, Observable, of, switchMap } from 'rxjs';
import { RolesCacheService } from '../roles-cache.service';

@Pipe({
  name: 'roles',
  standalone: false,
})
export class RolesPipe implements PipeTransform {
  private readonly rolesCacheService = inject(RolesCacheService);
  private readonly store = inject(Store);
  private readonly abilityService =
    inject<AbilityService<AnyAbility>>(AbilityService);

  transform(roles: string[]): Observable<boolean> {
    return this.abilityService.ability$.pipe(
      map((ability) =>
        ability.can(RoleAction.Read, RolePermissionSubject.Role),
      ),
      switchMap((hasPermission) => {
        if (!hasPermission) {
          return of(false);
        } else {
          return this.store.select(AuthState.userId).pipe(
            filter((userId) => !!userId),
            switchMap((userId) =>
              this.rolesCacheService.getRolesFromCache(userId as string),
            ),
            map((userRoles: UserRole[]) => {
              return !!userRoles.find((userRole) =>
                roles.includes(userRole.role?.name ?? ''),
              );
            }),
          );
        }
      }),
    );
  }
}
